import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-about-datasets',
    templateUrl: './about-datasets.component.html',
    styleUrls: ['./about-datasets.component.less'],
    standalone: false
})
export class AboutDatasetsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
